import {
    PROVIDERS_REQUEST_START,
    PROVIDERS_REQUEST_SUCCESS,
    PROVIDERS_REQUEST_FAILED,
    PROVIDERS_REQUEST_NO_PERMISSION,
    PROVIDERS_OPEN_FORM,
    PROVIDER_DEAL_CHANGED,
    PROVIDERS_UPDATE_REQUEST_START,
    PROVIDERS_UPDATE_REQUEST_SUCCESS,
    PROVIDER_NAME_CHANGED,
    PROVIDER_INSERT,
    PROVIDER_UPDATE,
    PROVIDER_CHANGED

}
    from '../actions/ProvidersActions';

const initialState = {
    status: 'Initialize',
    updateStatus: 'Initialize',
    data: [],
    provider: null
};

export default function ProvidersReducer(state = initialState, action) {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case PROVIDERS_REQUEST_START:
            return {...state, status: 'request'};
        case PROVIDERS_REQUEST_SUCCESS:
            return {
                ...state,
                status: 'success',
                data: action.data.map(a => {
                    return {...a, deals: JSON.parse(a.deals)}
                }),
                provider: null
            };
        case PROVIDERS_REQUEST_NO_PERMISSION:
            return {...state, status: 'no_permission', provider: null};
        case PROVIDERS_REQUEST_FAILED:
            return {...state, status: 'error', provider: null};
        case PROVIDERS_OPEN_FORM:
            const newProviderState =
                (state.provider && (action.provider.id === state.provider.id))
                    ? null : action.provider;
            return {
                ...state,
                provider: newProviderState
            };

        case PROVIDERS_UPDATE_REQUEST_START:
            return {...state, updateStatus: 'request'};

        case PROVIDERS_UPDATE_REQUEST_SUCCESS:
            return {...state, updateStatus: 'success'};

        case PROVIDER_NAME_CHANGED:
            let providerNewNameState = {...state.provider};
            providerNewNameState[action.field] = action.value;
            return {...state, provider: providerNewNameState};

        case PROVIDER_CHANGED:
            const providerNewState = {...state.provider};

            switch (action.change) {
                case 'delete':
                    const newDeleteFieldState = [...providerNewState[action.field]].filter((line, index) => index !== action.index);
                    providerNewState[action.field] = newDeleteFieldState;
                    break;
                case 'update':
                    const newUpdateFieldState = [...providerNewState[action.field]];
                    newUpdateFieldState[action.index] = action.value;
                    providerNewState[action.field] = newUpdateFieldState;
                    break;
                case 'add':
                    const newAddFieldState = [...state.provider[action.field], action.value];
                    providerNewState[action.field] = newAddFieldState;
                    break;
                default:
                    break;
            }
            return {
                ...state,
                provider: providerNewState
            };

        case PROVIDER_DEAL_CHANGED:
            const providerDealNewState = {...state.provider.deals[action.index]};
            providerDealNewState[action.field] = action.value;
            const newLinesState = [...state.provider.deals];
            newLinesState[action.index] = providerDealNewState;
            const providerDealChangeNewState = {...state.provider, deals: newLinesState};
            return {
                ...state,
                provider: providerDealChangeNewState
            };

        case PROVIDER_INSERT:

            var modifiedOffers = [];
            for (var index in state.data) {
                modifiedOffers.push(state.data[index]);
            }

            for (var index in action.data) {
                modifiedOffers.push(action.data[index]);
            }

            return {...state, data: modifiedOffers, errorUpdate: false};
        case PROVIDER_UPDATE:
            let data = action.data[0];
            const updatedProviders = state.data.map((p, idx) => {
                if(data.id === p.id && idx === action.index){
                    return data;
                }
                else{
                    return p;
                }
            });

            let afterUpdate = [...state.data];
            afterUpdate[action.index] = JSON.parse(JSON.stringify(data));

            return {...state, data: updatedProviders, errorUpdate: false};
        default:
            return state;
    }
}
